import React from 'react';
import CastingService from '../../../services/CastingService';

const RequsitionDownload = () => {
    const handleDownloadImages = async () => {
        try {
          const response = await CastingService.RequstionImageDownload();
      
          if (!response || !response.data) {
            throw new Error('No file received from server');
          }
      
          const blob = new Blob([response.data], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
      
          const link = document.createElement('a');
          link.href = url;
          link.download = 'requisition_images.zip';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error downloading ZIP:', error);
        }
      };
      

  return (
    <button className="btn btn-primary" onClick={handleDownloadImages}>
      Download Requisition Images
    </button>
  );
};

export default RequsitionDownload;
